import CvPreview from './src/components/CvPreview.vue'
import SalaryEdit from './src/components/SalaryEdit.vue'
import UploadDialog from './src/components/UploadDialog.vue'
import FileList from './src/pages/FileList.vue'
import FileTable from './src/components/FileTable.vue'
import TextUploadDialog from './src/components/TextUploadDialog.vue'
import PublicPreview from './src/components/PublicPreview.vue'

export { CvPreview, SalaryEdit, UploadDialog, FileList, FileTable, TextUploadDialog, PublicPreview }
